import {
  all,
  call,
  cancelled,
  put,
  takeLatest,
} from "redux-saga/effects";
import AudienceService from "../../services/AudienceService";

import {
  listSuccess,
  listFail,
  createSuccess,
  createFail,
  detailsSuccess,
  detailsFail,
  updateDetailSuccess,
  updateDetailFail,
  audienceUserListSuccess,
  audienceUserListFail,
  audienceAssignmentistSuccess,
  audienceAssignmentistFail,
  addAssignmentSuccess,
  addAssignmentFail,
  deleteSuccess,
  deleteFail,
  deleteAssignmentSuccess,
  deleteAssignmentFail,
  exportUsersSuccess,
  exportUsersFail,
} from "../slices/audienceSlice";

function* list(data) {
  try {
    const ajax = yield call(AudienceService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* create(data) {
  try {
    const ajax = yield call(AudienceService.create, data.payload);
    if (ajax.status === 200) {
      yield put(createSuccess(ajax.data));
    } else {
      yield put(
        createFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      createFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* details(data) {
  try {
    const ajax = yield call(AudienceService.details, data.payload);
    if (ajax.status === 200) {
      yield put(detailsSuccess(ajax.data));
    } else {
      yield put(
        detailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      detailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* update(data) {
  try {
    const ajax = yield call(AudienceService.update, data.payload);
    if (ajax.status === 200) {
      yield put(updateDetailSuccess(ajax.data));
    } else {
      yield put(
        updateDetailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateDetailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* users(data) {
  try {
    const ajax = yield call(AudienceService.users, data.payload);
    if (ajax.status === 200) {
      yield put(audienceUserListSuccess(ajax.data));
    } else {
      yield put(
        audienceUserListFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      audienceUserListFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* exportUsers(data) {
  try {
    const { fileType = "excel" } = data.payload;

    let extension = "xlsx";
    if (fileType === "csv") {
      extension = "csv";
    } else if (fileType === "pdf") {
      extension = "pdf";
    }

    const ajax = yield call(AudienceService.export, data.payload);
    if (ajax.status === 200) {
      const url = window.URL.createObjectURL(new Blob([ajax.data]), {
        type: ajax.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `cohort_users.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      yield put(exportUsersSuccess());
    } else {
      yield put(
        exportUsersFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      exportUsersFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* assignmentList(data) {
  try {
    const ajax = yield call(AudienceService.assignments, data.payload);
    if (ajax.status === 200) {
      yield put(audienceAssignmentistSuccess(ajax.data));
    } else {
      yield put(
        audienceAssignmentistFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      audienceAssignmentistFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* addAssignment(data) {
  try {
    const ajax = yield call(AudienceService.addAssignment, data.payload);
    if (ajax.status === 200) {
      yield put(addAssignmentSuccess(ajax.data));
    } else {
      yield put(
        addAssignmentFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      addAssignmentFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* deleteAssignment(data) {
  try {
    const ajax = yield call(AudienceService.deleteAssignment, data.payload);
    if (ajax.status === 200) {
      yield put(deleteAssignmentSuccess(ajax.data));
    } else {
      yield put(
        deleteAssignmentFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      deleteAssignmentFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* deleteAudience(data) {
  try {
    const ajax = yield call(AudienceService.delete, data.payload);
    if (ajax.status === 200) {
      yield put(deleteSuccess(ajax.data));
    } else {
      yield put(
        deleteFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      deleteFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* audienceSaga() {
  yield all([
    // Latest only, like the other list sagas: the cohort picker searches as
    // the admin types, and an older answer must not replace a newer one
    takeLatest("audiences/listRequest", list),
    takeLatest("audiences/createRequest", create),
    takeLatest("audiences/detailsRequest", details),
    takeLatest("audiences/updateDetailRequest", update),
    takeLatest("audiences/audienceUserListRequest", users),
    takeLatest("audiences/audienceAssignmentistRequest", assignmentList),
    takeLatest("audiences/addAssignmentRequest", addAssignment),
    takeLatest("audiences/deleteRequest", deleteAudience),
    takeLatest("audiences/deleteAssignmentRequest", deleteAssignment),
    takeLatest("audiences/exportUsersRequest", exportUsers),
  ]);
}
